<template>
  <div>
    <!-- 主体信息 -->
    <el-card class="box-card box">
      <div
        class="dialoTitle"
        style="position: relative;"
      >
        <span style="font-size:15px;">收件信息</span>
        <el-button
          class="edit"
          @click="addSubject"
          :disabled="isOperate"
        >添加</el-button>
      </div>
      <div
        class="info"
        style="padding-top:0px!important"
      >
        <!-- 详情列表和编辑 -->
        <div
          class="empty-content"
          v-if="isShow=='1'"
        >
          <img
            src="@/assets/user_images/nothing.png"
            alt=""
            class="empty-img"
          >
          <div class="empty-desc">您还没有创建收件信息哦，快去添加吧！</div>
          <el-button
            type="primary"
            @click="addSubject"
            class="empty-add"
          >添 加</el-button>
        </div>
        <el-collapse
          v-if="isShow=='2'"
          v-model="activeNames"
          accordion
          @change="handleChange"
        >
          <template>
            <div
              v-for="(items,index) in subjectList"
              :key="index"
            >
              <el-collapse-item :name="index+1">
                <template slot="title">
                  <div class="item-title">{{cutName(items.recipients)}}</div>
                  <div class="item-heard">
                    <div class="item-name"> {{items.recipients}}</div>
                    <div class="item-phone">{{items.receivePhone}}</div>
                  </div>
                  <br />
                  <div class="item-address">{{items.receiveAddress}}</div>
                  <el-button
                    class="edit"
                    :disabled="isOperate"
                    style="right:0px;top:12px"
                  >{{activeNames==(index+1)?'收起':'展开'}}</el-button>
                  <!-- <el-button
                    class="edit"
                    @click.stop="editSubject(items,index+1)"
                    :disabled="editSubjectTrans(index,items.type)"
                    style="right:0px"
                  >编辑
                  </el-button> -->
                </template>
                <el-form
                  :inline="false"
                  :model="subjectInfo"
                  class="demo-form-inline"
                  style="padding-top:30px; padding-bottom:20px;"
                  label-position="right"
                  label-width="100px"
                  ref="subjectInfo"
                  :rules="rules"
                  v-if="index==currentSubjectIndex"
                >
                  <el-row class="row">
                    <el-col :span="24">
                      <el-form-item
                        label="收件人"
                        prop="recipients"
                      >
                        <el-input
                          v-model="subjectInfo.recipients"
                          placeholder="请输入收件人"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item
                        label="联系电话"
                        prop="receivePhone"
                      >
                        <el-input
                          v-if="isEditForm"
                          v-model="subjectInfo.receivePhone"
                          placeholder="请输入联系电话"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item
                        label="收件地址"
                        prop="receiveAddress"
                      >
                        <el-input
                          v-if="isEditForm"
                          v-model="subjectInfo.receiveAddress"
                          placeholder="请输入收件地址"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col
                      :span="24"
                      v-if="isEditForm"
                    >
                      <el-form-item label="">
                        <div>
                          <el-button
                            type="primary"
                            @click="updateSubject('subjectInfo')"
                            style="color:#fff;background: #13c2c2;margin-right:10px;"
                          >保存</el-button>
                          <el-button @click="cancel">取消</el-button>

                        </div>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </el-collapse-item>
            </div>
          </template>
        </el-collapse>
        <!-- 添加 -->
        <div v-if="isAdd">
          <el-form
            :inline="false"
            :model="addSubjectInfo"
            class="demo-form-inline"
            label-position="right"
            label-width="100px"
            ref="addSubjectInfo"
            :rules="rules"
          >
            <div class="info">
              <el-row class="row">
                <el-col :span="24">
                  <el-form-item
                    label="收件人"
                    prop="recipients"
                  >
                    <el-input
                      v-model="addSubjectInfo.recipients"
                      placeholder="请输入收件人名称"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item
                    label="联系电话"
                    prop="receivePhone"
                  >
                    <el-input
                      v-model="addSubjectInfo.receivePhone"
                      placeholder="请输入联系电话"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item
                    label="收件地址"
                    prop="receiveAddress"
                  >
                    <el-input
                      v-model="addSubjectInfo.receiveAddress"
                      placeholder="请输入收件地址"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="">
                    <el-button
                      type="primary"
                      @click="createSubjectInfo('addSubjectInfo')"
                      style="margin-right:10px;"
                    >保存</el-button>
                    <el-button @click="cancel('isAdd')">取消</el-button>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>

          </el-form>
        </div>
      </div>
    </el-card>
  </div>

</template>

<script>
/*
salesmanList   商务业务员列表
provinceList  所有省数据
invoickList   支付主体
cityList    所有市数据
areaList      所有有区/县数据
flag  判断邮箱是否重复
*/
import jq from 'jquery'
import data from '@/api/getArea'
import { validateEmail, addBasicInfo, checkSubjectName } from "@/api/api"
import { validateTelphone, validateTelphoneUn, taxPointCheck } from "@/api/validate"
import { getDictList, getAuthFlag, getAddress, statusTrans } from "@/api/dataTrans"
import { getAllInfo, allMeijie, updateBasicInfo, updateReceiveInfo, addReceiveInfo, getCreditLine, creditLine } from "@/api/siter.js"
import serve from "@/utils/request"
export default {
  data () {
    return {
      //默认0，1表示空，2表示非空
      isShow: 0,
      keyValue: 0,
      isEditForm: true, //  主体信息是否开启编辑
      currentSubjectIndex: 0,//当前展开主体窗口的数据下标
      creadit: null,
      salesmanName: null,
      isEdit: false,
      isAddReceive: false,
      isOperate: false,
      basicOperate: false,
      isAdd: false,
      isReceive: false,
      attributList: [],
      basicInfo: {
        id: null,
        userId: null,
        recipients: null,
        receivePhone: null,
        receiveAddress: null
      },
      addreciveInfo: {
        recipients: null,
        receivePhone: null,
        receiveAddress: null,
      },
      submitData: {
        id: null,
        userId: null,
        recipients: null,
        receivePhone: null,
        receiveAddress: null
      },
      addSubjectInfo: {
        id: null,
        userId: null,
        recipients: null,
        receivePhone: null,
        receiveAddress: null
      },
      subjectInfo: {},
      subjectList: [],
      activeNames: [0],
      detail: "展开",
      retract: "收起",
      id: null,
      isDisabled: false,
      currentSubject: null,
      currentReceive: null,
      uId: null,
      salesmanList: [],
      provinceList: [],
      invoickList: [],
      cityList: [],
      areaList: [],
      flag: false,
      dialog: false,
      rules: {
        receivePhone: [
          { required: true, validator: validateTelphone, trigger: 'change' }
        ],
        receiveAddress: [
          { required: true, message: '必选项不能为空', trigger: 'change' },
          { max: 80, message: '长度不能超过80', trigger: 'change' }
        ],
        recipients: [
          { required: true, message: '必选项不能为空', trigger: 'change' },
          { max: 20, message: '长度不能超过20', trigger: 'change' }
        ],
      },
      subjectId: 0
    }
  },
  mounted () {
    this.attributList = getDictList(207)
    // allMeijie().then(res => {
    //   if (res && res.code == 0) {
    //     this.salesmanList = res.data.items
    //   }
    // })
    // this.id = this.$route.query.userId
    //获取流量主所有信息
    this.getAll()
    // getCreditLine({
    //   trafficId: this.id
    // }).then(res => {
    //   if (res && res.code == 0) {
    //     this.creadit = res.data
    //   }
    // })
  },
  methods: {
    transAddress (_p, _c, _a) {
      return "123"
      // return getAddress(_p, _c, _a)
    },
    //详细地址转换
    addressTrans (_p, _c, _a, _d) {
      var _address1 = getAddress(_p, _c, _a)
      var _result = ''
      if (_d == null) {
        _result = _address1
      } else {
        _result = _address1 + _d
      }
      if (_result == null || _result == "") {
        _result == "--"
      }
      return _result
    },
    updateCreadit () {
      this.dialog = true
    },
    handleClose () {
      this.dialog = false
      getCreditLine({
        trafficId: this.id
      }).then(res => {
        if (res && res.code == 0) {
          this.creadit = res.data
        }
      })
    },
    //获取用户汇总信息
    getAll (_openIdx) {
      getAllInfo({
        trafficId: this.id
      }).then(res => {
        if (res && res.code == 0) {
          this.id = res.data.trafficUserNewVO.id
          //流量主详情列表
          this.subjectList = res.data.trafficReceivingInfoVOS
          if (this.subjectList.length > 0) {
            this.isShow = 2
          } else {
            this.isShow = 1
          }
          if (_openIdx) {
            this.activeNames = this.currentSubjectIndex + 1
          } else {
            this.currentSubjectIndex = this.subjectList.length - 1
            this.activeNames = res.data.trafficReceivingInfoVOS.length
          }
          //当前单项主体信息
          this.subjectInfo = this.subjectList[this.currentSubjectIndex]
          this.getCityList()
        }
      })
    },
    //当前展开主体信息编辑按钮启禁用
    editSubjectTrans (_idx, _type) {
      // if(_type=='1'){
      //   if(this.currentSubjectIndex == _idx){
      //     return false
      //   }
      // }else{
      //   return false
      // }
      var _result = false
      if (this.currentSubjectIndex == _idx) {
        if (_type == '1') {
          _result = false
        } else {
          _result = true
        }
      } else {
        if (_type == '1') {
          _result = false
        } else {
          _result = true
        }
      }
      return _result
    },
    // 编辑收件信息
    editBasic () {
      this.isEdit = true
      this.isOperate = true
      this.basicOperate = true
      this.getCityList()
      this.getAreaList()
      this.changColor()
    },
    //取消操作
    cancel (val) {
      this[`${val}`] = false
      this.isOperate = false
      this.basicOperate = false
      this.currentSubject = null
      this.currentReceive = null
      var arr = document.getElementsByClassName(' el-icon-arrow-right')
      for (var i = 0; i < arr.length; i++) {
        arr[i].style.color = "#13c2c2"
      }
      this.getAll()
    },
    // 添加流量主收件信息
    createSubjectInfo (formName) {
      const _this = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          _this.addSubjectInfo.userId = _this.id
          addReceiveInfo(_this.addSubjectInfo).then(res => {
            if (res && res.code == 0) {
              this.$message.success("添加成功")
              Object.assign(this.$data.addSubjectInfo, this.$options.data().addSubjectInfo)
              this.getAll()
              this.isOperate = false
              this.isAdd = false
            }
          })
        } else {
          return false;
        }
      })
    },
    // 编辑收件信息
    updateSubject (formName) {
      const _this = this
      this.$refs[formName][0].validate((valid) => {
        if (valid) {
          updateReceiveInfo(_this.subjectInfo).then(res => {
            if (res && res.code == 0) {
              this.$message.success("更新成功")
              //初始化状态
              this.isOperate = false
              this.currentSubject = null
              Object.assign(this.$data.addSubjectInfo, this.$options.data().addSubjectInfo)
            }
          })
          this.isOperate = false
        } else {
          return false;
        }
      })
    },
    // 新建收件信息
    createReceive (formName) {
      const _this = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          addReceiveInfo(_this.addreciveInfo).then(res => {
            if (res && res.code == 0) {
              this.getAll()
              // this.$message.success("添加成功")
              Object.assign(this.$data.addreciveInfo, this.$options.data().addreciveInfo)
              this.isOperate = false
              this.isAddReceive = false
            }
          })
        } else {
          return false;
        }
      })
    },
    // 更新收件人
    updateReceive (formName, val) {
      const _this = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          updateReceiveInfo(val).then(res => {
            if (res && res.code == 0) {
              this.$message.success("更新成功")
              this.isOperate = false
              this.currentReceive = null
            }
          })
        } else {
          return false;
        }
      })
    },
    // 更新基本信息
    updateBasicInfo (formName) {
      const _this = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          updateBasicInfo(this.basicInfo).then(res => {
            if (res && res.code == 0) {
              this.isOperate = false
              this.isEdit = false
              this.getAll()
            }
          })
        } else {
          return false;
        }
      })
    },
    addSubject () {
      if (this.isShow != 2) {
        this.isShow = 0
      }
      this.currentSubjectIndex = null
      this.subjectId = 0
      this.isOperate = true
      this.isAdd = true
      this.changColor()
    },
    //编辑主体信息
    editSubject (val, idx) {
      const _this = this
      _this.activeNames = [idx]
      _this.subjectId = val.id
    },
    // 编辑收件信息
    editReceive (val) {
      this.isOperate = true
      this.currentReceive = val
      this.changColor()
    },
    //空字符串转换
    emptyTrans (_val) {
      console.log(JSON.stringify(_val))
      if (_val == null || _val == undefined || _val == '') {
        return '--'
      } else {
        return _val
      }
    },
    handleChange (val) {
      if (val != "") {
        this.currentSubjectIndex = val - 1
        this.subjectInfo = this.subjectList[this.currentSubjectIndex]
      }
      var eles = document.getElementsByClassName("operate")
      for (var i = 0; i < eles.length; i++) {
        if (parseInt(val - 1) == i) {
          eles[i].innerHTML = "收起"
        } else {
          eles[i].innerHTML = "展开"
        }
      }
    },
    // 选择省以后获取对应的市的数据
    changeCensusProvince () {
      this.basicInfo.city = null
      this.basicInfo.area = null
      this.getCityList()
    },
    changColor () {
      var arr = document.getElementsByClassName(' el-icon-arrow-right')
      for (var i = 0; i < arr.length; i++) {
        arr[i].style.color = "rgba(0,0,0,0.25)"
      }
    },
    //区县选择监听
    changeCensusCounty (_val) { },
    // 提交
    back () {
      this.$router.push('/userManage/siterManagement')
    },
    //截取用户名称
    cutName (_val) {
      if (_val) {
        return _val.substring(1, 0);
      } else {
        return ''
      }
    },
    onSubmit (formName) {
      const _this = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.isDisabled = true
          // 删除对象属性
          // this.$delete(this.submitData, 'taxPoint1');//vue方法
          // this.$delete(this.submitData, 'taxPoint2');//vue方法
          var parmas1 = {
          }
          var parmas2 = {
          }
          var parmas3 = {
          }
          addBasicInfo(parmas1).then(res => {
            if (res && res.code == 0) {
              _this.uId = res.data.id
              parmas2.userId = res.data.id
              parmas3.userId = res.data.id
              // this.submitOthers(parmas2, parmas3)
            } else {
              // this.$message({
              //   type: 'error',
              //   message: res.msg
              // })
            }
          })

        } else {
          return false;
        }
      })

    },
  }
}
</script>
<style scoped lang="scss">
/deep/.el-card__body {
  padding: 0px;
}
/deep/.el-collapse-item__header {
  height: 98px;
}
.changColor {
  color: rgba(0, 0, 0, 0.25);
  font-size: 14px;
  position: absolute;
  right: 24px;
  cursor: pointer;
  border: none;
  top: 10px;
}

.info {
  padding: 32px 24px;
}

/deep/.row .el-form-item__content {
  width: 60%;
}
/deep/.address .el-form-item__content {
  width: 100px;
}

/deep/.detailAdd .el-form-item__content {
  width: 400px;
}

.back {
  margin: 16px 0px 0px 24px;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.65);
  cursor: pointer;
  overflow: hidden;
}

.edit {
  color: rgba(19, 194, 194, 0.8);
  font-size: 14px;
  position: absolute;
  right: 24px;
  cursor: pointer;
  border: none;
  top: 10px;
}

.edit:hover {
  background-color: #fff;
  color: #13c2c2;
}

/deep/.btnDisable {
  color: rgba(0, 0, 0, 0.25);
  font-size: 14px;
  position: absolute;
  right: 24px;
  cursor: pointer;
  border: none;
  top: 16px;
}

/deep/.show {
  position: absolute !important;
  bottom: 8px !important;
  right: 100px !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  color: rgba(0, 0, 0, 0.25) !important;
  padding: 24px 0px;
}

/deep/.el-button.is-disabled {
  color: rgba(0, 0, 0, 0.25);
  background-color: #ffffff !important;
}

.look {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.85);
}
/deep/.receive .el-form-item {
  margin-bottom: 0px;
}

.receive {
  border-bottom: 1px solid #e9e9e9;
}

/deep/.operate {
  position: absolute !important;
  bottom: -28px !important;
  right: 80px !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  color: #14c2c2 !important;
  padding: 24px 0px;
  cursor: pointer;
}

/deep/.editOperate {
  position: absolute !important;
  bottom: 8px !important;
  right: 30px !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  color: #14c2c2 !important;
  padding: 24px 0px;
  cursor: pointer;
}
/deep/.el-collapse-item__content {
  padding-bottom: 0px;
}
/deep/.el-collapse-item__header {
  border: none;
  border-top: 1px solid rgba(0, 0, 0, 0.05);
  color: rgba(0, 0, 0, 0.85);
  font-weight: 700;
  font-size: 14px !important;
  position: relative;
}

/deep/.el-collapse {
  border: none;
}

/deep/.el-collapse-item__wrap {
  background-color: #f8f8f8;
}

/deep/.el-collapse-item__arrow {
  position: absolute;
  bottom: 60px;
  right: 42px;
  color: #13c2c2;
  font-size: 14px;
  transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  /* IE 9 */
  -moz-transform: rotate(90deg);
  /* Firefox */
  -webkit-transform: rotate(90deg);
  /* Safari 和 Chrome */
  -o-transform: rotate(90deg);
  /* Opera */
}

/deep/.el-collapse-item__header .is-active {
  transform: rotate(-90deg);
  -ms-transform: rotate(-90deg);
  /* IE 9 */
  -moz-transform: rotate(-90deg);
  /* Firefox */
  -webkit-transform: rotate(-90deg);
  /* Safari 和 Chrome */
  -o-transform: rotate(-90deg);
  /* Opera */
}

/deep/.el-form-item__label {
  font-weight: 600 !important;
}

/deep/.app-main {
  overflow-y: scroll;
}

/deep/.el-table td {
  text-align: center;
}

/deep/.el-table th {
  text-align: center;
}

.dialoTitle {
  padding: 28px 0px;
  font-size: 14px;
  color: #000;
  text-indent: 24px;
  font-weight: 500;
  border-bottom: 1px solid rgba($color: #000000, $alpha: 0.05);
}
.is-disabled {
  background-color: none;
}
/deep/.el-form-item__label {
  color: rgba(0, 0, 0, 0.65);
  font-weight: 400;
}

/deep/.el-select {
  width: 100%;
}

.address {
  display: flex;
  justify-content: center;
}
.empty-content {
  text-align: center;
  margin-top: 120px;
  .empty-img {
    width: 206px;
    height: 148px;
  }
  .empty-desc {
    margin-top: 40px;
    font-size: 14px;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.65);
    line-height: 20px;
  }
  .empty-add {
    margin-top: 16px;
  }
}
// .el-button {
//   &:focus {
//     background-color: #fff;
//   }
// }
.item-title {
  position: absolute;
  left: 0px;
  width: 48px;
  height: 48px;
  background: linear-gradient(
    135deg,
    rgba(16, 0, 0, 0.1) 0%,
    rgba(0, 0, 0, 0.2) 100%
  );
  text-align: center;
  line-height: 48px;
  font-size: 14px;
  color: #ffffff;
  border-radius: 50%;
}
.item-heard {
  position: absolute;
  left: 70px;
  top: 0px;
  .item-name {
    color: rgba($color: #000000, $alpha: 0.85);
    display: inline-block;
    font-size: 16px;
  }
  .item-phone {
    display: inline-block;
    font-size: 14px;
    line-height: 48px;
    margin-left: 24px;
    color: rgba($color: #000000, $alpha: 0.45);
  }
}
.item-address {
  position: absolute;
  top: 40px;
  left: 70px;
  font-size: 14px;
  color: rgba($color: #000000, $alpha: 0.85);
}
</style>